var map = {
	"./birth-date.svg": 15721,
	"./boy.svg": 69292,
	"./calendar-365.svg": 37032,
	"./calendar.svg": 52283,
	"./card.svg": 76674,
	"./copy-icon.svg": 38057,
	"./crown-profile.svg": 23891,
	"./doctor-icon.svg": 97505,
	"./face-id-icon-blue.svg": 84932,
	"./face-id-icon-white.svg": 79948,
	"./free-icon-user.svg": 25902,
	"./girl.svg": 20639,
	"./man.svg": 61160,
	"./med-card.svg": 80747,
	"./phone-call.svg": 67891,
	"./plus.svg": 35340,
	"./star-profile.svg": 8877,
	"./trash-bin-icon.svg": 36034,
	"./ufo.svg": 25493,
	"./woman.svg": 39672
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 23273;